import { VisuallyHidden } from "@99tech/ui";
import { Box, Stack } from "@mui/material";
import React, { useCallback, useContext } from "react";
import {
  BankAndApp,
  Bg,
  BtnLogin,
  BtnRegister,
  Chars,
  Logo,
  Providers,
  TextContent,
  TextContent2,
  TextHead,
  TextHead2,
} from "src/assets";
import { AppContext } from "src/main/constants";
import { createStyles, isMobile } from "src/main/utils";

interface LandingPageProps extends React.PropsWithChildren {}

const LandingPage: React.FC<LandingPageProps> = (props) => {
  const { urls } = useContext(AppContext);
  const { loginUrl, registerUrl } = urls ?? {};

  const handleClick = useCallback(
    (type: "login" | "register") => (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (type === "login") {
        window.open(loginUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      } else {
        window.open(registerUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      }
    },
    [loginUrl, registerUrl],
  );

  return (
    <Box sx={styles.root}>
      <VisuallyHidden as="h1">WOWID</VisuallyHidden>
      <Stack
        direction="column"
        alignItems="center"
        width="100%"
        textAlign="center"
      >
        <img
          alt="text-head"
          src={TextHead}
          style={{ width: 336 }}
        />

        <img
          alt="logo"
          src={Logo}
          style={{ width: 306, marginTop: "-22px" }}
        />

        <img
          alt="text-head-2"
          src={TextHead2}
          style={{ width: 310, marginTop: "-20px" }}
        />

        <Stack
          direction="row"
          justifyContent="center"
          zIndex={10}
        >
          <a
            href={loginUrl}
            onClick={handleClick("login")}
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="btn-login"
              src={BtnLogin}
              style={{ height: 48 }}
            />
          </a>
          <a
            href={registerUrl}
            onClick={handleClick("register")}
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="btn-register"
              src={BtnRegister}
              style={{ height: 48 }}
            />
          </a>
        </Stack>

        <img
          alt="chars"
          src={Chars}
          style={{ width: 360, marginTop: "-4px" }}
        />

        <img
          alt="text-content"
          src={TextContent}
          style={{ width: 360, marginTop: "-16px" }}
        />

        <img
          alt="providers"
          src={Providers}
          style={{ width: 304, marginTop: "-8px" }}
        />

        <img
          alt="text-content-2"
          src={TextContent2}
          style={{ width: 336, marginTop: "0px" }}
        />

        <img
          alt="bank-and-app"
          src={BankAndApp}
          style={{ width: 190, marginTop: "-4px" }}
        />
      </Stack>
    </Box>
  );
};

const styles = createStyles({
  root: {
    backgroundImage: `url(${Bg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    backgroundColor: "#03103E",

    p: "16px",
    mx: "-16px",

    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    gap: "0px",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    overflowX: "hidden",
    color: "#fff",
  },
});

export default LandingPage;
